import Toggle from "../classes/toggle";

export function InitTeamCards() {
	const teamCards = document.querySelectorAll('.team_section .card.team');
	if (teamCards.length === 0) return;

	teamCards.forEach((teamCard) => {
		const button = teamCard.querySelector('a.team-show-more-info');

		const toggleButton = new Toggle(button, () => {
			teamCard.classList.toggle('collapsed');
		});
	});
}
